class TypingAnimation {
  constructor(element) {
    this.element = element;
    const fullText = element.textContent.trim();
    this.texts = fullText.split('|').map(t => t.trim());
    this.currentTextIndex = 0;
    this.isDeleting = false;
    this.pauseTime = 2000;
    this.deleteTime = 1000;
    
    this.element.classList.add('typing-active');
    
    this.showText();
  }

  showText() {
    const currentText = this.texts[this.currentTextIndex];
    
    // Use exact glowIn logic
    var letters = currentText.split("");
    this.element.textContent = "";
    letters.forEach((letter, i) => {
      var span = document.createElement("span");
      span.textContent = letter;
      span.className = `char char-${i % 3}`;
      span.style.animationDelay = i * 0.05 + "s";
      this.element.append(span);
    });
    
    // Wait, then delete
    const totalAnimationTime = letters.length * 50 + this.pauseTime;
    setTimeout(() => this.deleteText(), totalAnimationTime);
  }

  deleteText() {
    this.element.classList.add('deleting');
    
    setTimeout(() => {
      this.element.classList.remove('deleting');
      this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length;
      this.showText();
    }, this.deleteTime);
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const richTextElements = document.querySelectorAll('.rich-text__text p');
  
  richTextElements.forEach(element => {
    if (element.textContent.includes('|')) {
      new TypingAnimation(element);
    }
  });
});